import { createAction, createAsyncAction } from 'typesafe-actions';
import { Admin, Contractor } from '../../../models';

export const loginRequestAction = createAction(
  'MED_APP/GENERAL/SIGN_IN'
)<{
  email: string;
  password: string;
  role?: string;
}>();


export const loginAction = createAsyncAction(
  'MED_APP/ADMIN/SIGN_IN/REQUEST',
  'MED_APP/ADMIN/SIGN_IN/SUCCESS',
  'MED_APP/ADMIN/SIGN_IN/FAIL',
)<
  {
    email: string;
    password: string;
  },
  { user: Admin; token: string },
  any
>();

export const signUpAction = createAsyncAction(
  'MED_APP/ADMIN/SIGN_UP/REQUEST',
  'MED_APP/ADMIN/SIGN_UP/SUCCESS',
  'MED_APP/ADMIN/SIGN_UP/FAIL',
)<
  {
    email: string;
    password: string;
  },
  { user: Admin; token: string },
  any
>();


export const loginContractorAction = createAsyncAction(
  'MED_APP/CONTRACTOR/SIGN_IN/REQUEST',
  'MED_APP/CONTRACTORN/SIGN_IN/SUCCESS',
  'MED_APP/CONTRACTOR/SIGN_IN/FAIL',
)<
  {
    email: string;
    password: string;
    role: string;
  },
  { user: Contractor; token: string },
  any
>();

export const setAuthUser = createAction('MED_APP/GENERAL/SET_AUTH_USER')<{ user: Admin | Contractor }>();

export const logoutAction = createAsyncAction(
  'MED_APP/GENERAL/SIGN_OUT/REQUEST',
  'MED_APP/GENERAL/SIGN_OUT/SUCCESS',
  'MED_APP/GENERAL/SIGN_OUT/FAIL',
)<
  {
    deviceUid?: string
  },
  { done: boolean },
  any
>();